<template>
  <Form :label-width="80">
    <Row>
      <Col span="24">
      <FormItem label="患者头像：">
        <img :src="patientData.profileImgUrl" style="max-height: 125px;max-width: 100%">
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="患者编号：">{{patientData.id}}</FormItem>
      </Col>
      <Col span="12">
      <FormItem label="患者名称：">{{patientData.name}}</FormItem>
      </Col>
      <Col span="12">
      <FormItem label="患者性别：">{{patientData.sex === '0'?'男':patientData.sex === '1'?'女':'-'}}</FormItem>
      </Col>
      <Col span="12">
      <FormItem label="患者账号：">{{patientData.phone}}</FormItem>
      </Col>
      <Col span="12">
      <FormItem label="患者生日：">{{moment(patientData.birthday).format('YYYY-MM-DD ')}}</FormItem>
      </Col>
      <Col span="12">
      <FormItem label="患者身高：">{{patientData.height}}cm</FormItem>
      </Col>
      <Col span="12">
      <FormItem label="患者体重：">{{patientData.weight}}kg</FormItem>
      </Col>
      <Col span="12">
      <FormItem label="患者状态：">{{patientData.isLock?"已禁用":"在使用"}}</FormItem>
      </Col>
      <Col span="8">
      <FormItem label="创建时间：">{{moment(patientData.createTime).format('YYYY-MM-DD HH:mm:ss')}}</FormItem>
      </Col>
      <Col span="24">
      <FormItem label="联系人：">
        <Table stripe max-height="250" :columns="connectTitle" :data="patientData.connectList"></Table>
      </FormItem>
      </Col>
    </Row>
  </Form>
</template>

<script>
  import Moment from 'moment'
  export default {
    name: "patient-info-module",
    components: {
      Moment,
    },
    props: {
      patientData: {
        type: Object,
        default: null
      },
    },
    data() {
      return {
        moment: Moment,
        connectTitle:[
          {
            type: 'index',
            width: 50,
            align: 'center',
          },
          {
            title: '联系人姓名',
            key: 'name',
            align: 'center',
          },
          {
            title: '联系人号码',
            key: 'phone',
            align: 'center',
          },
          {
            title: '联系人地址',
            key: 'address',
            align: 'center'
          }
        ],
      }
    },
  }
</script>

<style scoped>

</style>
